import ModalFooter from 'LuxKit/Modal/ModalFooter'
import useRestoreCartButtonProps from 'tripPlanner/hooks/useRestoreCartButtonProps'
import type { LETripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: LETripItem
}

function RestoreCartModalFooter({ item }: Props) {
  const { canRestoreCart, label, onClick } = useRestoreCartButtonProps(item)

  if (!canRestoreCart) return null

  return (
    <ModalFooter
      primaryActionProps={{
        children: label,
        onClick,
      }}
    />
  )
}

export default RestoreCartModalFooter
